export class EventSourceConnection {
	private eventSource: EventSource

	constructor(connect: (token: string) => EventSource) {
		const token = localStorage.getItem('accessToken')
		if (!token) throw new Error('No token found')
		this.eventSource = connect(token)

		const handleConnection = (response: string) => {
			console.log("SSE connected:", response)
		}

		const handleError = () => {
			this.close()
		}

		this.registerListener<string>("INIT", handleConnection)
		this.eventSource.onerror = handleError
	}

	public handleResponse<T>(callback: (data: T) => void, e: MessageEvent<any>, raw = false) {
		console.log(e)
		try {
			const payload = raw ? e.data : this.tryParse(e.data)
			callback(payload as T)
		} catch (error) {
			console.error('Error handling SSE response:', error)
		}
	}

	private tryParse(data: string) {
		try {
			return JSON.parse(data)
		} catch {
			return data
		}
	}

	public registerListener<T>(name: string, callback: (data: T) => void, raw = false) {
		this.eventSource.addEventListener(name, (e: MessageEvent<any>) =>
			this.handleResponse(callback, e, raw)
		)
	}

	public unregisterListener(name: string, callback: (e: MessageEvent<any>) => void) {
		this.eventSource.removeEventListener(name, callback)
	}

	public close() {
		this.eventSource.close()
	}
}
